<template>
    <transition name="fade-in-up">
        <router-view />
    </transition>
</template>

<script>
import { SET_MENU } from '@/core/services/store/modules/menu.module';
import { SideBar } from '@/core/config/menu/sideBar';

export default {
    name: 'WarrantyService',
    mounted() {
        this.$store.dispatch(SET_MENU, SideBar.WARRANTY_SERVICE);
    },
};
</script>
